module.exports = __webpack_public_path__ + "asset/image-Bed-5c1e84f7ff39b0d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Bed.svg
// module id = wC4o
// module chunks = 0